<div *ngIf="displayPlans$ | async as plans">
  <p
    class="typog-body-large appliance-selection-subheading pt-3 pb-6"
    *ngIf="!showOnlyAssistance"
  >
    Pick the appliance you’d like help with.
  </p>
  <dgx-components-grid-section
    [themeFlush]="true"
    [themeSpacing]="'none'"
    class="mb-5 mt-6 custom-background"
  >
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column
          [xs]="0"
          [lg]="2"
        ></dgx-components-grid-column>
        <dgx-components-grid-column
          [xs]="12"
          [lg]="8"
          *ngIf="!showOnlyAssistance"
        >
          <div class="radio-container plan-selection">
            <ng-container *ngFor="let plan of plans">
              <a
                class="radio-icon-button"
                [ngClass]="{ selected: plan.isActive }"
                (click)="onSelectPlan(plan)"
                data-testid="plan-selector"
              >
                <dgx-components-icon
                  [icon]="'check-circle'"
                  [size]="'sm'"
                  class="radio-icon-button__check"
                  data-testid="selected-icon"
                />
                <p class="typog-body-large-bold mb-1">
                  {{
                    (
                      plan.item.manufacturer +
                      ' ' +
                      plan.item.code_description
                    ).toLowerCase()
                  }}
                </p>
                <p>Plan number: {{ plan.plan_number }}</p></a
              >
            </ng-container>
          </div>
        </dgx-components-grid-column>
        <dgx-components-grid-column
          [xs]="0"
          [lg]="2"
        ></dgx-components-grid-column>
      </dgx-components-grid-row>
      <dgx-components-grid-row
        *ngIf="(activePlan$ | async) || (hasLocalSelection$ | async)"
        class="assistance-section"
      >
        <dgx-components-grid-column>
          <p
            class="typog-body-large appliance-selection-subheading pt-5 pb-5"
            id="assistance"
          >
            What help do you need?
          </p></dgx-components-grid-column
        >
      </dgx-components-grid-row>
      <dgx-components-grid-row
        *ngIf="(activePlan$ | async) || (hasLocalSelection$ | async)"
        class="assistance-section"
      >
        <dgx-components-grid-column
          [xs]="0"
          [lg]="2"
        ></dgx-components-grid-column>
        <dgx-components-grid-column [xs]="12" [lg]="8">
          <div
            *ngIf="selectedAssistance$ | async as selectedAssistance"
            class="radio-container plan-selection"
            data-testid="assistance-type"
          >
            <a
              class="radio-icon-button"
              [ngClass]="{ selected: selectedAssistance === 'Repair' }"
              (click)="selectAssistance.emit('Repair')"
            >
              <dgx-components-icon
                [icon]="'check-circle'"
                [size]="'sm'"
                class="radio-icon-button__check"
              />
              <p class="typog-body-large-bold">Repair</p>
              <p>Let’s get your appliance working again.</p></a
            >
            <a
              class="radio-icon-button"
              [ngClass]="{ selected: selectedAssistance === 'Care tips' }"
              (click)="selectAssistance.emit('Care tips')"
            >
              <dgx-components-icon
                [icon]="'check-circle'"
                [size]="'sm'"
                class="radio-icon-button__check"
              />
              <p class="typog-body-large-bold">Care tips</p>
              <p>Get help to keep it running smoothly.</p></a
            >
          </div>
          <ng-container *ngIf="!(isContinueLoading$ | async); else loading">
            <div class="continue-button-container">
              <dgx-components-button
                *ngIf="
                  ((activePlan$ | async) || (hasLocalSelection$ | async)) &&
                  (selectedAssistance$ | async) != 'None'
                "
                (clicked)="onContinue()"
                [disabled]="(isContinueLoading$ | async) || false"
                [type]="'button'"
                [variant]="'primary'"
                class="continue-button"
                data-testid="continue-button"
                [fill]="true"
                (keydown.enter)="onContinue()"
              >
                Continue
                <dgx-components-icon [icon]="'arrow-right'" [size]="'md'" />
              </dgx-components-button>
            </div>
          </ng-container>
          <ng-template #loading>
            <dgx-components-loading-overlay></dgx-components-loading-overlay>
          </ng-template>
        </dgx-components-grid-column>
        <dgx-components-grid-column
          [xs]="0"
          [lg]="2"
        ></dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>
</div>
